import { defaultsDeep, get, isFunction, merge, set, unset, update } from 'lodash';
import shortId from 'shortid';
import type { IScope } from './Scope.interface';

export default class Scope implements IScope {
  Root: Object;
  Current: Object;
  State: Object;
  TimeOut: Object;
  WebPage: Object;
  Event: Object;
  Auth: Object;
  Defaults: Object;

  apply = () => this.TimeOut(() => this.Current?.$apply());

  read = (isRoot: boolean = false) => (isRoot ? this.Root : this.Current);

  get = (path?: string, isRoot: boolean = false) => get(this.read(isRoot), path);

  publish = () => {
    this.set({ Scope: { Root: this.Root, Current: this.Current } });
  };

  remove = (path?: string, isRoot: boolean = false) => {
    unset(this.read(isRoot), path);
    this.apply();
  };

  set = (value?: any, isUpdated: boolean = false, isRoot: boolean = false) => {
    merge(
      this.read(isRoot),
      isUpdated ? merge(value, { ComponentUpdated: shortId.generate() }) : value
    );
    this.apply();
  };

  transitionTo = () => this.State?.transitionTo();

  update = (
    path?: string,
    value?: any,
    isUpdated: boolean = false,
    isRoot: boolean = false
  ) => {
    const newValue = isUpdated ? merge(value, { ComponentUpdated: shortId.generate() }) : value;
    if (isFunction(value)) {
      update(this.read(isRoot), path, newValue);
    } else {
      set(this.read(isRoot), path, newValue);
    }
    this.apply();
  };

  /**
   * Constructor
   * @param {IScope} scope
   */
  constructor(scope?: IScope) {
    this.Root = scope?.Root || {};
    this.Current = defaultsDeep(scope?.Current || {}, scope?.Defaults || {});
    this.State = scope?.State || {};
    this.TimeOut = scope?.TimeOut || {};
    this.WebPage = scope?.WebPage || {};
    this.Event = scope?.Event || {};
    this.Auth = scope?.Auth || {};

    this.publish();
  }
}
